import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

export const BarrasHorasSemanaEmpleado = ({ data, jornada }) => {
    const convertirHoras = (decimales) => {
        const horas = Math.floor(decimales);
        const minutos = Math.round((decimales - horas) * 60);
        return `${horas} horas${minutos > 0 ? ` ${minutos} minutos` : ''}`;
    };

    const obtenerFechaCompleta = (diaTexto) => {
        const match = diaTexto.match(/[A-Z](\d{1,2})\/(\d{1,2})/);
        if (!match) return diaTexto;
        const dia = parseInt(match[1], 10);
        const mes = parseInt(match[2], 10) - 1;
        const hoy = new Date();
        const fecha = new Date(hoy.getFullYear(), mes, dia);

        const diasLargos = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const mesesLargos = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

        return `${diasLargos[fecha.getDay()]} ${fecha.getDate()} de ${mesesLargos[fecha.getMonth()]}`;
    };

    // Preparar los datos
    const datos = data.map((item) => {
        const tareas = item.tareas || [];
        const tareasData = tareas.reduce((acc, t) => ({ ...acc, [t.nombre]: t.horas }), {});

        return {
            ...item,
            // Jornada: jornada,    // <-- AÑADIDO: barra de jornada para todos los días
            total: convertirHoras(item.base + item.excedente),
            fechaCompleta: obtenerFechaCompleta(item.dia),
            ...tareasData,
        };
    });

    // Obtener nombres únicos de tareas
    const tareasNombres = Array.from(
        new Set(data.flatMap(d => d.tareas?.map(t => t.nombre) || []))
    );

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload;

            const tareasKeys = Object.keys(item).filter(
                (key) =>
                    !['dia', 'base', 'excedente', 'floor', 'total', 'fechaCompleta'].includes(key) &&
                    typeof item[key] === 'number'
            );

            return (
                <div
                    style={{
                        backgroundColor: 'var(--fondo)',
                        padding: '8px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        position: 'relative',
                        zIndex: 999999, // aquí lo importante
                        boxShadow: '0 2px 8px rgba(59, 59, 59, 0.15)',
                    }}
                >
                    <strong>{item.fechaCompleta}</strong><br />
                    Total: {item.total}<br />
                    {tareasKeys.length > 0 && (
                        <div style={{ marginTop: '6px' }}>
                            {/* <strong>Jornada:</strong> */}
                            <ul style={{ paddingLeft: '16px', margin: 0 }}>
                                {tareasKeys.map((tarea) => {
                                    const horas = item[tarea];
                                    const h = Math.floor(horas);
                                    const m = Math.round((horas - h) * 60);
                                    return (
                                        <li key={tarea}>
                                            {tarea}: {h}h{m > 0 ? ` ${m}min` : ''}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                </div>
            );
        }
        return null;
    };



    return (
        <div style={{ width: datos.length * 16, height: 90, backgroundColor: "rgba(190, 190, 190, 0.8)", padding: '4px', borderRadius: '8px' }}>
            <ResponsiveContainer width="100%" height="100%" >
                <BarChart data={datos} barCategoryGap={8} >
                    <YAxis hide />
                    <Tooltip
                        content={<CustomTooltip />}
                        cursor={{ fill: 'rgba(0,0,0,0.10)' }}
                        offset={12}   // lo coloca justo encima
                    />
                    {/* Barra de jornada (fondo) */}
                    {/* <Bar
                        dataKey="Jornada"
                        fill="rgba(0,0,0,0.10)"
                        barSize={6}
                        stackId="background"
                    /> */}

                    {/* Barras reales */}

                    <Bar dataKey="base" stackId="1" fill="var(--principal)" barSize={6} />
                    <Bar dataKey="excedente" stackId="1" fill="var(--secundario)" barSize={6} />

                    {/* Tareas */}
                    {tareasNombres.map((nombre, index) => (
                        <Bar
                            key={nombre}
                            dataKey={nombre}
                            stackId="2"
                            fill={`hsl(${(index * 60) % 360}, 70%, 60%)`}
                            barSize={6}
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};
